import Size from "@/util/Size.ts";
import {createContext, RefObject, useContext} from "react";
import Konva from "konva";

export type ResponsiveStageReturn = {
    stageSize: Size,
    stageMeasured: boolean,
    setStageSize: (stageSize: Size) => void,
    stageRef: RefObject<Konva.Stage | null>,
}

export const ResponsiveStageContext = createContext<ResponsiveStageReturn | null>(null);

export const useStage = (): ResponsiveStageReturn => {
    const stage = useContext(ResponsiveStageContext);
    if (!stage) {
        throw new Error("useStage must be used within a Provider");
    }
    return stage;
}
